import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {isEmpty, validationChecker} from "../../../../components/commonmethod/CommonMethod";
import {saveLease} from "../../../../api/asset/AssetLeaseService";
import Th_title from "../../../../components/Th_title";
import {useDispatch, useSelector} from "react-redux";
import {apiLoading} from "../../../../redux/slice/apiSlice";
import {inputOnChange} from "../../../../components/commonmethod/simmsInputMethod";
import SimmsInput from "../../../../components/input/SimmsInput";
import {onCreateClickListener} from "../../../../components/commonmethod/simmsDrawerMethod";
import Selector from "../../../../components/selector/Selector";
import SimmsDatePicker from "../../../../components/datepicker/SimmsDatePicker";
import {dateOnChange} from "../../../../components/commonmethod/simmsDateMethod";
import dayjs from "dayjs";
import {cn} from "../../../../shadCn/lib/utils";
import SimmsTextArea from "../../../../components/input/SimmsTextArea";
import SearchSelector from "../../../../components/searchSelector/SearchSelector";
import UserSelectionField from "../../../../components/selection/UserSelectionField";
import {AssetSearchFilters} from "../../mng/info/shared/AssetSearchFilters";
import SimmsInputSearch from "../../../../components/input/SimmsInputSearch";
import {handleActiveError, handleActiveToast} from "../../../../components/sonner/ToastBasic";
import {
    ContentDetailTwoColLayout,
    DetailFilePanel,
    DetailFormPageShell,
    DetailKvReadOnly,
    DetailKvTable,
    DetailListPage,
    DetailPanel,
    DetailSummaryButton,
} from "../../../../components/detailLayout";
import "../../../../components/detailLayout/detailListLayout.css";

function AssetLeaseCreate() {
    const platFrom = useSelector(state => state.auth.platFrom);
    const user = useSelector(state => state.auth.user);
    const currentDate = new Date();
    const [lease, setLease] = useState({});
    const [assets, setAssets] = useState([]);
    const [contracts, setContracts] = useState([]);
    const [docs, setDocs] = useState([]);
    const navigate = useNavigate();
    const requireds = ["name", "company"];
    const dispatch = useDispatch();

    const create = async () => {
        if (!validationChecker(lease)) return;

        if (requireds.some(e => isEmpty(lease[e]))) {
            alert("필수값이 누락되었습니다.");
            return;
        }

        dispatch(apiLoading(true));

        const docFile = [];
        docs.forEach(each => docFile.push(each.object));

        const updatedData = {
            ...lease,
            company: {id: lease.company.id}
        };

        await saveLease(updatedData, docFile, assets, contracts).then(response => {
            if (response.status === 200) {
                handleActiveToast({message: "등록되었습니다."});
                const newId = response.data?.id;
                if (newId) {
                    navigate(`/asset/lease/${newId}`, {state: {id: newId}});
                } else {
                    navigate("/asset/lease");
                }
            } else if (response.status === 201 || response.status === 202) {
                handleActiveError({message: response.data.title, description: response.data.reason});
            } else {
                handleActiveError({message: "등록에 실패하였습니다."});
            }
        }).finally(() => dispatch(apiLoading(false)));
    };

    return (
        <DetailFormPageShell
            className="common-container container-height-full border-l-gray create-page detail-list-layout asset-detail-list-layout"
            title="리스 등록"
            meta="신규 리스 정보를 입력하세요"
            actions={
                <>
                    <DetailSummaryButton muted onClick={() => navigate("/asset/lease")}>
                        취소
                    </DetailSummaryButton>
                    <DetailSummaryButton
                        onClick={() => {
                            if (window.confirm("등록 하시겠습니까?")) {
                                create();
                            }
                        }}
                    >
                        등록
                    </DetailSummaryButton>
                </>
            }
        >
            <DetailListPage isEditing className="flex min-h-0 flex-1 flex-col">
                <div className="container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col overflow-hidden">
                    <ContentDetailTwoColLayout
                        main={
                        <DetailPanel title="기본정보">
                            <DetailKvTable>
                                <tbody>
                                <tr>
                                    <DetailKvReadOnly label="등록일시" value={currentDate.toISOString()} type="date"/>
                                    <DetailKvReadOnly label="수정일시" value=""/>
                                </tr>
                                <tr>
                                    <DetailKvReadOnly label="등록자" value={user.name}/>
                                    <DetailKvReadOnly label="수정자" value=""/>
                                </tr>
                                <tr>
                                    <Th_title title="리스명" colspan={3} className="fieldset-td" required auth>
                                        <SimmsInput onChange={(v) => inputOnChange(setLease, "name", v, true)} data={lease.name}/>
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title="리스 계약차수" colspan={1} className="fieldset-td" auth>
                                        <SimmsInput onChange={(v) => inputOnChange(setLease, "contractCount", v, false)} data={lease.contractCount}/>
                                    </Th_title>
                                    <Th_title title="리스 계약번호" colspan={1} className="fieldset-td" auth>
                                        <SimmsInput onChange={(v) => inputOnChange(setLease, "number", v, false)} data={lease.number}/>
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title="업체명" colspan={3} className="fieldset-td" required auth>
                                        <Selector
                                            onChange={(v) => onCreateClickListener(setLease, "company", lease.company, v)}
                                            data={lease.company}
                                            entity="company"
                                            uniqueKey="company"
                                        >
                                            <SimmsInputSearch type="TEXT" placeHolder="업체명"/>
                                        </Selector>
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title="계약기간" colspan={3} className="fieldset-td fieldset-td-input">
                                        <div className="web-flex asset-detail-date-range">
                                            <SimmsDatePicker
                                                onChange={(v) => dateOnChange(setLease, "leaseStartDate", v, false)}
                                                data={lease.leaseStartDate}
                                                constraint={{lessThan: lease.leaseEndDate && dayjs(lease.leaseEndDate)}}
                                                auth
                                            />
                                            <span className={cn("ml-2 mr-1 text-[20px]")}> ~ </span>
                                            <SimmsDatePicker
                                                onChange={(v) => dateOnChange(setLease, "leaseEndDate", v, false)}
                                                data={lease.leaseEndDate}
                                                constraint={{largerThan: lease.leaseStartDate && dayjs(lease.leaseStartDate)}}
                                                auth
                                            />
                                        </div>
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title="취득원가" colspan={1} className="fieldset-td" auth>
                                        <SimmsInput onChange={(v) => inputOnChange(setLease, "cost", v, false)} data={lease.cost}/>
                                    </Th_title>
                                    <Th_title title="1회 리스료(10회)" colspan={1} className="fieldset-td" auth>
                                        <SimmsInput onChange={(v) => inputOnChange(setLease, "price", v, false)} data={lease.price}/>
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title="비고" colspan={3} className="fieldset-td fieldset-td-input" auth>
                                        <SimmsTextArea
                                            onChange={(v) => inputOnChange(setLease, "etc", v, false)}
                                            data={lease.etc}
                                            style={{width: "100%", minHeight: "80px"}}
                                        />
                                    </Th_title>
                                </tr>
                                <tr className="asset-detail-kv-row--auto">
                                    <th>자산목록</th>
                                    <td colSpan={3} className="fieldset-td relative align-top">
                                        <UserSelectionField
                                            layout="inline"
                                            data={assets}
                                            countUnit="개"
                                            chipEntity="asset"
                                            listModalTitle="자산목록"
                                            onRemove={(v) => setAssets((prev) => prev.filter((asset) => asset.id !== v.id))}
                                        >
                                            <SearchSelector
                                                auth
                                                multiSelect
                                                variant="compact"
                                                entity="asset"
                                                uniqueKey="assets"
                                                data={assets}
                                                placeHolder="자산명"
                                                onChange={(v) => {
                                                    if (v?.__multiFlat) {
                                                        setAssets(v.__multiFlat);
                                                    }
                                                }}
                                            >
                                                <AssetSearchFilters platFrom={platFrom}/>
                                            </SearchSelector>
                                        </UserSelectionField>
                                    </td>
                                </tr>
                                <tr className="asset-detail-kv-row--auto">
                                    <th>계약목록</th>
                                    <td colSpan={3} className="fieldset-td relative align-top">
                                        <UserSelectionField
                                            layout="inline"
                                            data={contracts}
                                            countUnit="건"
                                            chipEntity="contract"
                                            listModalTitle="계약목록"
                                            onRemove={(v) =>
                                                setContracts((prev) => prev.filter((contract) => contract.id !== v.id))
                                            }
                                        >
                                            <SearchSelector
                                                auth
                                                multiSelect
                                                variant="compact"
                                                entity="contract"
                                                uniqueKey="contracts"
                                                data={contracts}
                                                placeHolder="계약명"
                                                onChange={(v) => {
                                                    if (v?.__multiFlat) {
                                                        setContracts(v.__multiFlat);
                                                    }
                                                }}
                                            >
                                                <SimmsInputSearch type="TEXT" placeHolder="계약명"/>
                                            </SearchSelector>
                                        </UserSelectionField>
                                    </td>
                                </tr>
                                </tbody>
                            </DetailKvTable>
                        </DetailPanel>
                        }
                        aside={
                        <DetailFilePanel
                            title="첨부"
                            isEditing
                            pendingFiles={{files: docs, setFiles: setDocs}}
                            pendingInputId="lease_create_doc"
                        />
                        }
                    />
                </div>
            </DetailListPage>
        </DetailFormPageShell>
    );
}

export {AssetLeaseCreate};
